import React, {useCallback} from 'react';
import {FaTimes,FaCheck} from 'react-icons/fa';
import {BiCabinet} from 'react-icons/bi';
import {QrScanner} from 'main/item/QrScanner';
import { useScreen } from '@putil-view/use.use-screen';
import PropTypes from 'prop-types';
export const ScanLockerQrCode = ({state, setState, uuid})=>{
	const screen = useScreen();
	const handleScanLockerQrCodeResult = useCallback(qr => {
		if (qr  && state.stage === 'SCAN_LOCKER_QR_CODE') {
			uuid.current = qr;
			setState(prevState =>{
					return{...prevState , ...{stage: "REQUEST_LOCKER_BY_UUID"}};
				}
			);
		}
	},[state.stage, uuid, setState])

	return (
		<>
			<QrScanner stopWhenDetach={true} style={{
					height: screen.isWideScreen ?'50vh':'45vh',
					width:  screen.isWideScreen ?'50vh':'100%',
					display:'flex',
					justifyContent: 'center',
					objectFit: 'cover'
			}} handleScan={handleScanLockerQrCodeResult}>
				{state.scanText.includes("Invalid") &&
					<h4 className="text-danger"><FaTimes/> {state.scanText}</h4>
				}

				{state.scanText.includes("Found") &&
					<h4>{state.scanText!== ""?<FaCheck/>:false} {state.scanText}</h4>
				}
			</QrScanner>

			<h5 className="text-center">Scan QR code on <BiCabinet/> Locker </h5>
		</>
	)
}
ScanLockerQrCode.propTypes = {
	state: PropTypes.object,
	setState: PropTypes.func,
	uuid: PropTypes.oneOfType([
		PropTypes.func, 
		PropTypes.shape({ current: PropTypes.string })
	])
};

